import { Action, createReducer, on } from '@ngrx/store';
import * as fromActions from './dynamic.actions';
import { initialDynamicState } from './dynamic.state';
import {
    GetActionsFromUiDefinition,
    InitActionsFromUiDefinition,
    AddUiDefinition,
    UpdateObjectProperty,
    UpdateValueInLocalStore,
    RemoveDataFromLocalStore,
    RemoveObjectProperty,
    UpdateArrayInLocalStore,
} from 'src/app/shared/helpers/store-helper';
import { UiDefinition } from '../models/ui-definition.models';
import { GetStore } from './dynamic.selectors';

const _dynamicReducer = createReducer(
    initialDynamicState,

    on(fromActions.initLocalStore, (state, action) => {
        var newState = {
            ...state,
            local: {
                UiDefValues: {},
                UiDefChilds: {},
            },
        };
        for (var i = state.actions.length - 1; i >= 0; i -= 1) {
            // remove subscription
        }
        newState.actions = InitActionsFromUiDefinition([], action.uiComponents);
        return newState;
    }),

    on(fromActions.initChildStore, (state, action) => {
        var newState = {
            ...state,
            local: AddUiDefinition(
                state.local,
                action.name,
                action.storeDataChildNames.slice(0, -1),
            ),
        };
        var actions = [...state.actions];
        for (var i = state.actions.length - 1; i >= 0; i -= 1) {
            if (
                state.actions[i].path
                    .toLowerCase()
                    .startsWith(action.name.toLowerCase())
            ) {
                actions.splice(i, 1);
                // Remove subscription
            }
        }
        newState.actions = [
            ...actions,
            ...InitActionsFromUiDefinition(
                action.storeDataChildNames,
                action.uiComponents,
            ),
        ];
        return newState;
    }),

    on(fromActions.removeActionFromStore, (state, action) => {
        var newState = {
            ...state,
        };
        var path =
            action.storeDataChildNames.length > 0
                ? action.storeDataChildNames.join('.')
                : '';
        var actions = [...state.actions];
        for (var i = state.actions.length - 1; i >= 0; i -= 1) {
            if (
                state.actions[i].path
                    .toLowerCase()
                    .startsWith(path.toLowerCase())
            ) {
                actions.splice(i, 1);
            }
        }
        newState.actions = [...actions];
        return newState;
    }),

    on(fromActions.saveDataInSessionStore, (state, action) => {
        return {
            ...state,
            session: UpdateObjectProperty(
                state.session,
                action.storeDataPath
                    ? `${action.storeDataName}.${action.storeDataPath}`
                    : action.storeDataName,
                action.newValue,
            ),
        };
    }),

    on(fromActions.saveDataInLocalStore, (state, action) => {
        var newState = { ...state };
        newState.local = UpdateValueInLocalStore(
            newState.local,
            action.storeDataPath
                ? `${action.storeDataName}.${action.storeDataPath}`
                : action.storeDataName,
            action.storeDataChildNames,
            action.newValue,
        );
        return newState;
    }),

    on(fromActions.saveDataInArrayWithIdInStore, (state, action) => {
        let newState = { ...state };
        if (action.storeName !== 'local') {
            console.warn(
                `saveDataInArrayWithIdInStore action is only implemented for local store. Store name: ${action.storeName}`,
            );
            return newState;
        } else {
            newState.local = UpdateArrayInLocalStore(
                newState.local,
                action.storeDataPath
                    ? `${action.storeDataName}.${action.storeDataPath}`
                    : action.storeDataName,
                action.idKey,
                action.idKeyValue,
                action.changeKey,
                action.changeValue,
                action.storeDataChildNames,
            );
            return newState;
        }
    }),

    on(fromActions.removeDataInStore, (state, action) => {
        var newState = { ...state };
        switch (action.storeName) {
            case 'local':
                newState.local = RemoveDataFromLocalStore(
                    newState.local,
                    action.storeDataPath
                        ? `${action.storeDataName}.${action.storeDataPath}`
                        : action.storeDataName,
                    action.storeDataChildNames,
                );
                break;
            case 'session':
                newState.session = RemoveObjectProperty(
                    newState.session,
                    action.storeDataPath
                        ? `${action.storeDataName}.${action.storeDataPath}`
                        : action.storeDataName,
                );
                break;
            default:
                console.warn(`Unknown store name: ${action.storeName}`);
        }
        if (action.actionName) {
            newState.local = UpdateValueInLocalStore(
                newState.local,
                'executingActions.' + action.actionName.toLowerCase(),
                action.storeDataChildNames,
                false,
            );
        }
        return newState;
    }),

    on(fromActions.getUiDefinitionFromUrl, (state, action) => {
        //console.log('#### UI Definition loading from URL:', action.url);
        return {
            ...state,
            uiDefinition: null as null,
        };
    }),

    on(fromActions.getUiDefinitionSuccess, (state, action) => ({
        ...state,
        uiDefinition: action.uiDefinition,
    })),

    on(fromActions.getPresentationSuccess, (state, action) => ({
        ...state,
        presentation: action.presentation,
    })),

    on(fromActions.executeAction, (state, action) => {
        let newState = { ...state };
        newState.local = UpdateValueInLocalStore(
            newState.local,
            'executingActions.' + action.actionName.toLowerCase(),
            action.storeDataChildNames,
            true,
        );
        return newState;
    }),

    on(fromActions.executeActionSuccess, (state, action) => {
        let newState = { ...state };
        if (!action.uiAction.startAnotherAction) {
            //console.log('#### Action executed successfully:', action.uiAction.name);
            newState.local = UpdateValueInLocalStore(
                newState.local,
                'executingActions.' + action.uiAction.name.toLowerCase(),
                action.storeDataChildNames,
                false,
            );
        }
        return newState;
    }),

    on(fromActions.executeActionFailed, (state, action) => {
        let newState = { ...state };
        newState.local = UpdateValueInLocalStore(
            newState.local,
            'executingActions.' + action.uiAction.name.toLowerCase(),
            action.storeDataChildNames,
            false,
        );
        return newState;
    }),
);

export function dynamicReducer(state = initialDynamicState, action: Action) {
    return _dynamicReducer(state, action);
}
